import { object, string, date } from "yup";

export const FORM_FIELD = {
  START_DATE: "start_date",
  END_DATE: "end_date",
  DESCRIPTION: "description",
};

export const validationSchema = object({
  [FORM_FIELD.START_DATE]: date().required(),
  [FORM_FIELD.END_DATE]: date()
    .nullable()
    .when([FORM_FIELD.START_DATE], (startDate, schema) => {
      const dayBuffer = new Date(startDate.getTime() + 86400000);

      return date().isValid(startDate)
        ? schema.min(
            dayBuffer,
            `Contract end date cannot be on or before ${startDate.toLocaleDateString()}`
          )
        : schema.notRequired();
    }),
  [FORM_FIELD.DESCRIPTION]: string().optional(),
});
